export const RecordList = ({ title, items, render, empty, testId, extra }) => (
  <div className="bg-white border border-stone-200 rounded-lg p-6" data-testid={testId}>
    <div className="flex items-center">
      <h3 className="font-heading text-base font-bold text-stone-900">{title}</h3>
      <span className="ml-2 text-xs text-stone-500">{items.length}</span>
      {extra && <div className="ml-auto">{extra}</div>}
    </div>
    <div className="mt-3 divide-y divide-stone-100 text-sm">
      {items.length === 0 && <p className="py-2 text-stone-500">{empty}</p>}
      {items.map((it) => <div key={it.id} className="py-3">{render(it)}</div>)}
    </div>
  </div>
);
